// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const TrendingUpIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M16.85 6.85l1.44 1.44-4.88 4.88-3.29-3.29a.996.996 0 00-1.41 0l-6 6.01a.996.996 0 101.41 1.41L9.41 12l3.29 3.29c.39.39 1.02.39 1.41 0l5.59-5.58 1.44 1.44a.5.5 0 00.85-.35V6.5a.48.48 0 00-.49-.5h-4.29a.5.5 0 00-.36.85z"/></svg>'} />;

TrendingUpIcon.displayName = 'TrendingUpIcon';

export default TrendingUpIcon;
